import React, { useState } from "react"
import Select, { components } from "react-select"
import makeAnimated from "react-select/animated"

import downIcon from "../../assets/Hub_Icons/downchevron.svg"
import upIcon from "../../assets/Hub_Icons/upchevron.svg"
import { customeStyles as dropdownStyles,Option } from "../../components/MultiSelect"


export const MultiSelect = (props) => {
    return (
        <div>
            <Select
                isMulti
                options={ props.options }
                name={ props.name }
                onChange={ (e) => props.onHandleChange({ ...e, name: props.name }) }
                className="basic-multy-select"
                classNamePrefix="select"
                placeholder={ props.placeholder }
            />
        </div>
    )
}


const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator { ...props }>
            <img alt="dropdown"
                src={ props.isFocused ? upIcon : downIcon }
                className=""
                height={ "16px" }
                width={ "16px" }
            />
        </components.DropdownIndicator>
    )
}

const ValueContainer = ({ children, ...props }) => {
    return (
        components.ValueContainer && (
            <components.ValueContainer { ...props }>
                { !!children && <i className="text-red absolute ml-3">*</i> }
                { children }
            </components.ValueContainer>
        )
    )
}

const borderError = "#34383f"

const customeStyles = {

    input: (styles) => ({
        ...styles,
        fontSize: "19px",
        lineHeight: "20px",
        color: { borderError },
        padding: "5px 10px 5px 0"
    }),
    placeholder: (styles, state) => ({
        ...styles,
        color: "#34383f",
        fontFamily: "Avenir",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "400"
    }),

    indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
    valueContainer: (base) => ({
        ...base,
        paddingLeft: 20

    }),
    control: (base, state) => ({
        ...base,
        borderRadius: 8,

        borderColor: state.isFocused ? "#003DA5" : "#CED0D6",
        boxShadow: null,
        backgroundColor: state.isFocused ? "#EDF5FF" : "#FFFFFF",
        "&:hover": {
            borderColor: state.isFocused ? "#003DA5" : "#CED0D6"
        }
    }),
    multiValue: (styles) => {
        return {
            ...styles,
            backgroundColor: "#F3F3F3",
            borderColor: "#CED0D6",
            borderRadius: 10
        }
    },
    multiValueLabel: (styles) => ({
        ...styles,
        color: "#3438F"
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: "#002466",
        ":hover": {
            backgroundColor: "#002466",
            color: "#FFFFFF"
        }
    })
}


export const GlobalSelect = (props) => {
    const getValue = (value, arr) => {
        if (arr !== undefined && arr.length > 0) {
            return arr.find(obj => obj.value.toString() == value)
        } else {
            return {}
        }
    }

    return (
        <div>
            <Select
                options={ props.options }
                styles={ customeStyles }
                value={ getValue(props.value, props.options) }
                name={ props.name }
                components={ props.isRequired ? { ValueContainer, DropdownIndicator } : { DropdownIndicator } }
                onChange={ (e) => props.onHandleChange({ ...e, name: props.name }) }
                placeholder={ props.placeholder }
                required={ props.isRequired ? true : false }
                isDisabled={ props.disabled ? props.disabled : false }
            />
        </div>
    )
}

export const animatedComponents = makeAnimated()

export const SelectDropdown = (props) => {

    const [isFocused, setIsFocused] = useState(props?.isFocused || false)
    const handleFocus = () => {
        setIsFocused(true)
    }
    const handleBlur = () => {
        setIsFocused(false)
    }

    const getValue = (value, arr) => {
        if (arr !== undefined && arr.length > 0) {
            if (props.isMulti) {
                return value?.split(",").map((id) => {
                    return arr.find(obj => obj.value.toString() == id)
                }
                )
            }
            else {
                return arr.find(obj => obj.value.toString() == value)
            }
        } else {
            return null
        }
    }

    return (

        <div className={ `relative  ${isFocused ? "focused" : ""}` }>
            <Select
                isMulti={ props.isMulti }
                name={ props.name }
                components={ props.isMulti ? {
                    Option,
                    DropdownIndicator,
                    animatedComponents
                } : {
                    DropdownIndicator,
                    animatedComponents
                    
                } }
                options={ props.options }
                styles={ { dropdownStyles, ...props.styles } }
                value={ getValue(props.value, props.options) }
                onChange={ (e) => { props.onHandleChange({ ...e, name: props.name }) } }
                onBlur={ () => { handleBlur() } }
                className="basic-multi-select"
                classNamePrefix="select"
                closeMenuOnSelect={ props.isMulti ? false : true }
                hideSelectedOptions={ false }
                placeholder={
                    !isFocused && (
                        <label
                            htmlFor={ props.name }
                            className={ `absolute flex text-sm text-secondary-50 peer-focus:scale-75 dark:text-secondary-50 duration-300 transform  top-2 z-10 origin-[0] bg-white  px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-text-secondary-50  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2  peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 cursor-text font-['Avenir'] font-normal ${isFocused || (props.value != null)
                                ? "!-translate-y-[21px top-[-11px] leading-[14px] scale-75"
                                : ""
                            }` }
                        >
                            {
                                <>
                                    { (props.isRequired) && <span className="text-red text-sm mr-1 flex leading-[14px]">
                                        *
                                    </span>
                                    }
                                    { props.placeholder }
                                </> }
                        </label>) 
                } 
                onFocus={ handleFocus }
                isDisabled={ props.disabled ? props.disabled : false }
            />
            { isFocused && (
                <label
                    htmlFor={ props.name }
                    className={ `absolute flex text-sm text-secondary-50 peer-focus:scale-75 dark:text-secondary-50 duration-300 transform  top-2 z-10 origin-[0] bg-white  px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-text-secondary-50  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2  peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 cursor-text font-['Avenir'] font-normal ${isFocused || (props.value != null)
                        ? "!-translate-y-[21px top-[-11px] leading-[14px] scale-75"
                        : ""
                    }` }
                >
                    {
                        <>
                            { (props.isRequired) && <span className="text-red text-sm mr-1 flex leading-[14px]">
                                *
                            </span>
                            }
                            { props.placeholder }
                        </> }
                </label>) }
            { props.errorData && <div className="text-red text-xs mt-1">{ props.errorData }</div> }
        </div>
    )
}
